import { render, staticRenderFns } from "./SuccessTransaction.vue?vue&type=template&id=7aff9180&scoped=true"
import script from "./SuccessTransaction.vue?vue&type=script&lang=js"
export * from "./SuccessTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff9180",
  null
  
)

export default component.exports